import { render, staticRenderFns } from "./simWXView.vue?vue&type=template&id=44071192&"
import script from "./simWXView.vue?vue&type=script&lang=js&"
export * from "./simWXView.vue?vue&type=script&lang=js&"
import style0 from "./simWXView.vue?vue&type=style&index=0&id=44071192&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports